import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private activeRequests = 0; // Contador de solicitudes activas
  private loadingSubject = new BehaviorSubject<boolean>(null);
  private customLoader: Map<CustomLoaders, Subject<boolean>> = new Map();

  public show() {
    this.activeRequests++;
    this.updateLoadingState();
  }

  public hide() {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }
    this.updateLoadingState();
  }

  public showCustomLoader(loader: CustomLoaders) {
    if (this.customLoader.has(loader)) {
      this.customLoader.get(loader).next(true);
    } else {
      this.customLoader.set(loader, new BehaviorSubject(true));
    }
  }

  public hideCustomLoader(loader: CustomLoaders) {
    if (this.customLoader.has(loader)) {
      this.customLoader.get(loader).next(false);
    }
  }

  public getCustomLoader(loader: CustomLoaders): Observable<boolean> {
    return this.customLoader.has(loader)
      ? this.customLoader.get(loader).asObservable()
      : of(false);
  }

  get loading$(): Observable<boolean> {
    return this.loadingSubject.asObservable().pipe(
      filter((value) => value !== null),
      distinctUntilChanged(),
    );
  }

  private updateLoadingState() {
    this.loadingSubject.next(this.activeRequests > 0);
  }
}

export enum CustomLoaders {
  HOTEL_AVAILABILITY,
}
